import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    collectionName: undefined,
    areaName: undefined,
    siteId: undefined,
    modelType: null,
    mostRecentlyUpdatedModelId: null,
    mostRecentlyUpdatedModelPage: undefined,
};
/**
 * Parses a location string (e.g. "?page=2&size=10&sort=name&order=asc")
 * into a page context object.
 */
const parseLocationToPageContext = (location) => {
    if (!location) {
        return null;
    }
    const locationPageQuery = location.split('?')[1];
    const query = new URLSearchParams(locationPageQuery);
    return {
        page: Number(query.get('page')) || null,
        size: Number(query.get('size')) || null,
        sort: query.get('sort') || null,
        order: query.get('order') || null,
    };
};
const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        switchArea: (state, action) => {
            state.areaName = action.payload;
        },
        switchSite: (state, action) => {
            state.siteId = action.payload;
        },
        switchModelType: (state, action) => {
            state.modelType = action.payload;
        },
        setCollectionName: (state, action) => {
            state.collectionName = action.payload;
        },
        setMostRecentlyUpdatedModelId: (state, action) => {
            state.mostRecentlyUpdatedModelId = action.payload;
            state.mostRecentlyUpdatedModelPage = null;
        },
        setMostRecentlyUpdatedModelPageContext: (state, action) => {
            state.mostRecentlyUpdatedModelId = action.payload.modelId;
            state.mostRecentlyUpdatedModelPage = parseLocationToPageContext(action.payload.location);
        },
    },
    selectors: {
        selectCollectionName: (state) => state.collectionName,
        selectAreaName: (state) => state.areaName,
        selectSiteId: (state) => state.siteId,
        selectModelType: (state) => state.modelType,
        selectMostRecentlyUpdatedModelId: (state) => state.mostRecentlyUpdatedModelId,
        selectMostRecentlyUpdatedModelPage: (state) => state.mostRecentlyUpdatedModelPage,
    },
});
export const { switchArea, switchSite, switchModelType, setCollectionName, setMostRecentlyUpdatedModelId, setMostRecentlyUpdatedModelPageContext, } = sessionSlice.actions;
export const { selectCollectionName, selectAreaName, selectSiteId, selectModelType, selectMostRecentlyUpdatedModelId, selectMostRecentlyUpdatedModelPage, } = sessionSlice.selectors;
export default sessionSlice.reducer;
